import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import RequestServices from '../../../services/RequestServices';
import Swal from 'sweetalert2';

const RequisitionEdit = ({ show, handleClose, test, item }) => {
  const [qtyRequired, setQtyRequired] = useState('');
  const [approveQty, setApproveQty] = useState('');
  const [status, setStatus] = useState('');

  useEffect(() => {
    if (item) {
      setQtyRequired(item.qtyRequired || '');
      setApproveQty(item.approveQty || '');
      setStatus(item.status || '');
    }
  }, [item]);
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!qtyRequired || !approveQty || !status) {
      Swal.fire({
        icon: 'warning',
        title: 'Warning',
        text: 'Required Quantity, Approved Quantity, and Status cannot be blank.',
      });
      return;
    }
  
    const updatedData = {
      qtyRequired,
      approveQty,
      status,
    };
  
    try {
      await RequestServices.updateItem(item._id, updatedData);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Item updated successfully!',
        timer: 2000,
        showConfirmButton: false,
      });
  
      setTimeout(() => {
        test((prev) => prev + 1);
        handleClose();
      }, 2000);
    } catch (error) {
      console.error('Error updating the item', error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'There was a problem updating the item. Please try again later.',
      });
    }
  };
  
  return (
    <Modal className="fade" show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title><i className="fas fa-edit"></i> Edit/Reject Requisition Item</Modal.Title>
          <Button variant="" className="btn-close" onClick={handleClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md="6">
                <label>Part No.</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={item?.inventory?.masterItem?.partNo || 'N/A'}
                  readOnly
                />
              </Col>
              <Col md="6">
                <label>Required Quantity</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={qtyRequired}
                  onChange={(e) => setQtyRequired(e.target.value)}
                />
              </Col>
              <Col md="6">
                <label>Approved Quantity</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={approveQty}
                  onChange={(e) => setApproveQty(e.target.value)}
                />
              </Col>
              <Col md="6">
                <label>Status</label>
                <select 
                  className="form-select form-control-sm"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="forceclosed">Rejected</option>
                  <option value="approved">Approved</option>
                </select>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit">
            Save Changes
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default RequisitionEdit;
